import React from 'react';

import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, KeyboardDatePickerProps, MuiPickersUtilsProvider } from '@material-ui/pickers';
import styled from 'styled-components';

import CalenderURL from 'src/medias/icons/calendar-icon.svg';

const CustomKeyboardDatePicker = styled(KeyboardDatePicker)(({ theme, error, disabled }) => ({
  marginTop: 0,
  border: error ? `1px solid red` : `1px solid rgba(0,0,0,0.1)`,
  borderRadius: 6,
  height: 40,
  padding: 5,
  paddingLeft: 14,
  backgroundColor: disabled ? '#E3E6EA' : 'white',
}));

const CalenderIconStyled = styled.img(() => ({
  top: -2,
}));

interface ICustomDatePicker {
  value: Date | null;
  isError?: boolean;
  name?: string;
  format?: string;
  variant?: string;
  disabled?: boolean;
  placeholder?: string;
  marginTop?: string;
}

export const CustomDatePicker = ({
  value,
  isError,
  name,
  format = 'dd/MM/yyyy',
  variant = 'inline',
  placeholder = 'DD/MM/YYYY',
  marginTop,
  disabled,

  ...props
}: ICustomDatePicker & KeyboardDatePickerProps) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <CustomKeyboardDatePicker
        {...props}
        disabled={disabled}
        placeholder={placeholder}
        error={isError}
        variant={variant}
        format={format}
        margin="normal"
        value={value}
        InputProps={{
          disableUnderline: true,
          readOnly: true,
        }}
        style={{ marginTop }}
        autoOk
        name={name}
        fullWidth
        invalidDateMessage=""
        minDateMessage=""
        maxDateMessage=""
        keyboardIcon={<CalenderIconStyled style={{ position: 'absolute' }} src={CalenderURL} />}
      />
    </MuiPickersUtilsProvider>
  );
};
